import React, { useEffect, useState } from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import Typography from "@material-ui/core/Typography";
import api from '../../services/api';
import { toast } from 'react-toastify';
import { useTheme } from "@material-ui/core/styles";
import { getChartTextColor, getChartGridColor } from "./chartTheme";
import { i18n } from "../../translate/i18n";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels
);

const buildOptions = (textColor, gridColor) => ({
    responsive: true,
    scales: {
        x: {
            ticks: {
                color: textColor,
            },
            grid: {
                color: gridColor,
            },
        },
        y: {
            beginAtZero: true,
            ticks: {
                color: textColor,
            },
            grid: {
                color: gridColor,
            },
        },
    },
    plugins: {
        legend: {
            position: 'top',
            display: true,
            labels: {
                color: textColor,
            },
        },
        title: {
            display: true,
            text: i18n.t('dashboard.charts.conversationsByUser.chartTitle'),
            position: 'left',
            color: textColor,
        },
        datalabels: {
            display: true,
            anchor: 'start',
            offset: -30,
            align: "start",
            color: "#fff",
            textStrokeColor: "#000",
            textStrokeWidth: 2,
            font: {
                size: 20,
                weight: "bold"

            },
        }
    },
});

export const ChatsUser = ({ initialDate, finalDate }) => {
    const [ticketsData, setTicketsData] = useState({ data: [] });
    const theme = useTheme();
    const isDark = theme.palette.type === "dark";
    const textColor = getChartTextColor(isDark);
    const gridColor = getChartGridColor(isDark);

    useEffect(() => {
        handleGetTicketsInformation(initialDate, finalDate);
    }, [initialDate, finalDate]);

    const dataCharts = {

        labels: ticketsData && ticketsData?.data.length > 0 && ticketsData?.data.map((item) => item.nome),
        datasets: [
            {
                label: i18n.t("dashboard.charts.conversationsByUser.dataset"),
                data: ticketsData?.data.length > 0 && ticketsData?.data.map((item, index) => {
                    return item.quantidade
                }),
                backgroundColor: '#2DDD7F',
            },

        ],
    };

    const handleGetTicketsInformation = async (selectedInitialDate, selectedFinalDate) => {
        try {
            if (!selectedInitialDate || !selectedFinalDate) {
                return;
            }

            const { data } = await api.get(`/dashboard/ticketsUsers`, {
                params: {
                    initialDate: selectedInitialDate,
                    finalDate: selectedFinalDate,
                },
            });
            setTicketsData(data);
        } catch (error) {
            toast.error(i18n.t('dashboard.charts.conversationsByUser.loadError'));
        }
    }

    return (
        <>
            <Typography component="h2" variant="h6" color="primary" gutterBottom>
                {i18n.t("dashboard.charts.conversationsByUser.title")}
            </Typography>
            <Bar options={buildOptions(textColor, gridColor)} data={dataCharts} style={{ maxWidth: '100%', maxHeight: '280px', }} />
        </>
    );
}